import { Party } from './../../../../models/party-manager/party';
import { PartyService } from './../../../../services/api/party/party.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, Validators, FormControl, FormBuilder } from '@angular/forms';
import { BreadcrumbsService } from 'src/app/services/utils/breadcrumbs.service';
import { TranslateService } from '@ngx-translate/core';
import { MatTableDataSource, MatSort, MatSnackBar } from '@angular/material';
import { Mapping } from 'src/app/models/interface/template/mapping';
import { TemplatesService } from 'src/app/services/api/templates/templates.service';
import { TemplateData } from 'src/app/models/interface/template/templateData';
import { Subscription } from 'rxjs';
import { NotificationsService, NotificationLevel } from 'src/app/services/api/notifications/notifications.service';
import { CatalogService} from 'src/app/services/api/catalog/catalog.service';
import { ServiceTemplate } from 'src/app/models/interface/serviceTemplate/serviceTemplate';

@Component({
  selector: 'app-new-template',
  templateUrl: './new-template.component.html',
  styleUrls: ['./new-template.component.scss']
})
export class NewTemplateComponent implements OnInit {

  form: FormGroup;

  tooltip = {
    submit: '',
    clear: ''
  }

  displayedColumns = [
    'territoryUser',
    'territoryOwner',
    'externalTemplateISP',
    'externalTemplateINO'
  ];

  dataSource: MatTableDataSource<Mapping>;
  @ViewChild(MatSort, null) sort: MatSort;

  serviceName: string;

  tiles: any[];

  inos: Party[];
  isps: Party[];
  table: any;
  subscription: Subscription;

  serviceTemplates: ServiceTemplate[];

  constructor(
    private formBuilder: FormBuilder,
    private breadcrumbsService: BreadcrumbsService,
    private router: Router,
    private translate: TranslateService,
    private templatesService: TemplatesService,
    private partyService: PartyService,
    private route: ActivatedRoute,
    private notificationsService: NotificationsService,
    private catalogService: CatalogService,
    private translateService: TranslateService
  ) {

  }

  ngOnInit() {
    this.breadcrumbsService.sendBreadcrumbs(
      {
        breadcrumbs:
          [
            { title: 'Administración', url: 'provision/management' },
            { title: 'Nuevo Template FTTH', url: 'provision/management/templates/new' }
          ]
      }
    );

    this.form = new FormGroup({
        isp: new FormControl('', Validators.required),
        serviceName: new FormControl('', Validators.required),
        serviceTemplate: new FormControl('', Validators.required),
    });

    this.table = {};
    this.table.colspan = 0;
    this.table.values = [];

    this.serviceName = '';


    this.partyService.getProviders().subscribe(data => this.inos = data);

    if (this.isps === null || this.isps === undefined) {

      this.partyService.getCustomers().subscribe(data =>{
        this.isps = data;
        this.init();
      })
    } else {
      this.init();
    }
  }

  private init() {
    const templateTypes = this.isps;
    templateTypes.sort(function (a, b) {
      return a.name.toLowerCase() < b.name.toLowerCase() ? -1 : (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : 0
    });

    this.dataSource = null;

    this.catalogService.getServiceTemplates().subscribe(
      (data) => {
        this.serviceTemplates = data.content;
      },
      (error) => {
        this.notificationsService.showNotification(this.translateService.instant('SERVICE_TEMPLATES_KEY.error'), NotificationLevel.ERROR);
      }
    );

    this.initTooltips();
    this.subscribeOnFormChange();
  }

  private initTooltips() {
    this.translate.get('DUMMY.key').subscribe((translated: string) => {
      this.tooltip.submit = this.translate.instant('TOOLTIPS.submitForm');
      this.tooltip.clear = this.translate.instant('TOOLTIPS.clearForm');
    });
  }

  
  private subscribeOnFormChange() {
    
  };


  public submitForm() {
    
  const mappingData: Mapping[] = [];

  mappingData.push({
    territoryOwner: this.inos.find(p=> p.name==="ADAMO").namingId,
    territoryReseller: this.form.controls['isp'].value,
    territoryUser: this.form.controls['isp'].value,
    externalTemplateISP: this.form.controls['serviceName'].value,
    externalTemplateINO: this.form.controls['serviceName'].value,
    tv: this.form.controls['serviceName'].value.includes('TV'),
  });

  const template: TemplateData = {
    value: this.form.controls['serviceName'].value,
    isActive: true,
    serviceTemplate: this.form.controls['serviceTemplate'].value,
    mappings: mappingData
  }
    this.templatesService.createTemplate(template).subscribe(
      () => {
        this.notificationsService.showNotification(`El Template ${template.value} se ha creado correctamente`, NotificationLevel.SUCCESS);
        this.router.navigate([`/provision/management/templates/search`]);
      },
      (error) => {
        this.notificationsService.showNotification(
          `Ha habido un problema al crear el template:\n${error.error.errorDesc.message}`, NotificationLevel.ERROR);
        this.router.navigate([`/provision/management/templates/search`]);
      });
  }

  public goToSearchTemplates() {
    this.router.navigate([`/provision/management/templates/search`]);
  }

  public clearForm() {
    this.form.reset();
  }

}
